import { ref } from 'vue'
import { useDjango } from '@/composables/useDjango'
import API from '@/api/apiUrls'

const { api } = useDjango()

export function useShapeFileUpload() {
  const loadingFieldNames = ref(false)
  const fieldNames = ref([])

  const resetSelectedField = () => {
    loadingFieldNames.value = false
    fieldNames.value = []
  }

  const fetchGeometryFieldNames = async (files: File[]) => {
    loadingFieldNames.value = true
    if (!files?.length) {
      return resetSelectedField()
    } else {
      const formData = new FormData()
      formData.append('file', files[0])
      try {
        fieldNames.value = await api.apiService.api(
          API.SECTION_GEO_DATA.GET_FIELD_NAMES,
          'POST',
          formData
        )
      } catch (error) {
        loadingFieldNames.value = false
      }
    }
    loadingFieldNames.value = false
  }

  return {
    loadingFieldNames,
    fieldNames,
    fetchGeometryFieldNames
  }
}
